import {
  collection,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import { StripeCharge } from "../types/StripeCharge";

export function useProjectCharges(projectId: string | null) {
  const [charges, setCharges] = useState<StripeCharge[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const q = query(
      collection(firestore, "projects", projectId, "charges"),
      orderBy("created", "desc"),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data() as StripeCharge);
      setCharges(data);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(() => ({ charges, isLoading }), [charges, isLoading]);
}
